<script>
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import {mapState, mapGetters} from "vuex";
    
    const DefaultProductDetails = {
        title: "Product Title",
        description: "Product Description",
        image: null,
        currency: "",
        price: "-",
        paymentPlans: []
    };

    export default {
        name: "PaymentManagerElement",
        mixins: [
            
        ],
        data() {
            return {
                elementType: 'payment-manager',
                givesContextToChildren: true,
                originalProductData: null,
                productData: null,
                checkoutData: null,
                additionalAuthenticatonFormData: {}                
            }
        },       
        computed: {
            ...mapState('components',['componentStates']),
            ...mapState(['currencySymbol']),
            ...mapGetters('products', {
                courseRepo: 'buyableCourses',
                bundleRepo: 'publicBundles',
                subscriptionRepo: 'publicSubscriptions'
            }),            
            getDefaultDataStructure () {
                return {
                  elementType: this.elementType,
                  elementId: this.elementId,
                  styles: null,
                  product: {
                      type: 'course',
                      id: null,
                      coupon: null
                  },
                  
                  itemVisibilitySettings: null
                }
            },
            getProduct(){
                return this.myData.product;
            },                 
            nestedComponentsMapping(){
                 return this.nestedComponentIds.map((id)=>{ 
                    return this.componentStates[id] || null; 
                });
            },
            authenticationComponent(){
                return this.nestedComponentsMapping.find(component => { 
                    return component && component.componentType == 'PaymentAuthentication';
                });
            },
            productDetailsComponent(){
                return this.nestedComponentsMapping.find(component =>  {
                    return component && component.componentType == 'PaymentProductDetails'; 
                });
            },
            billingInfoComponent(){
                return this.nestedComponentsMapping.find(component =>  {
                    return component && component.componentType == 'PaymentBillingInfo'; 
                });
            },
            paymentMethodComponent(){
                return this.nestedComponentsMapping.find(component =>  {
                    return component && component.componentType == 'PaymentMethod'; 
                });
            },
            paymentMessagesComponent(){
                return this.nestedComponentsMapping.find(component =>  {
                    return component && component.componentType == 'PaymentMessages';
                });
            },
            billingInfo(){
                return this.billingInfoComponent.getBillingInfo();
            },
            productDetailsSource(){
                if(!this.getProduct || !this.getProduct.type){
                    return [];
                }
                return this[`${this.getProduct.type}Repo`];
            },
            productDetails(){
                const productDetails = this.productDetailsSource.find(product =>this.getProduct.id === product.titleId );
                if(typeof productDetails == 'undefined'){                    
                    return this.getDefaultProductDetails;
                }
                return this.productDetailsMapping(productDetails);
            },
            getDefaultProductDetails(){
                return DefaultProductDetails;
            }
        },
        methods: {
             productDetailsMapping(product){
                if(!this.getProduct.id){
                    return {};
                }
                //Todo add the mapping if needed
                switch(this.getProduct.type){
                    case "course":
                        return {...product, image: product.courseImage.url, description: product.keywords };
                    break;
                    case "bundle":
                        return {...product, discountPrice: product.discount_price, id: product.titleId, type: 'Model\\Bundle'  };
                    break;    
                    case "subscription":
                        return {...product, id: product.titleId, type: 'Model\\Subscription', paymentPlans: []  };
                    break;
                    default:
                        return product;
                    break   

                }    
            },
            setCoupon(coupon){
                
            },
            requestValidation(){

            },
            updateAuthenticationForm(value){
               
            }

        }
        
    }
</script>
